module.exports = __webpack_public_path__ + "img/sport-31-@1x.4156c172.png";